var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 1.06 1.06",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 0.88c0.02,0 0.04,0.02 0.04,0.05 0,0.02 -0.02,0.04 -0.04,0.04l-0.18 0c-0.01,0 -0.03,0 -0.05,-0.01l0 0c-0.02,-0.01 -0.03,-0.01 -0.04,-0.03l0 0c-0.01,-0.01 -0.02,-0.02 -0.03,-0.04l0 0c-0.01,-0.02 -0.01,-0.03 -0.01,-0.05l0 -0.62c0,-0.01 0,-0.03 0.01,-0.05 0.01,-0.01 0.02,-0.03 0.03,-0.04 0.01,-0.01 0.03,-0.02 0.04,-0.03 0.02,-0.01 0.04,-0.01 0.05,-0.01l0.18 0c0.02,0 0.04,0.02 0.04,0.04 0,0.03 -0.02,0.05 -0.04,0.05l-0.18 0c0,0 -0.01,0 -0.01,0 -0.01,0 -0.01,0.01 -0.02,0.01 0,0.01 -0.01,0.01 -0.01,0.02 0,0 0,0.01 0,0.01l0 0.62c0,0.01 0,0.01 0,0.02l0 0c0,0 0.01,0.01 0.01,0.01 0.01,0.01 0.01,0.01 0.01,0.01l0.01 0c0,0 0.01,0 0.01,0l0.18 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.74 0.78c-0.02,0.02 -0.05,0.02 -0.06,0 -0.02,-0.01 -0.02,-0.04 0,-0.06l0.19 -0.19 -0.19 -0.19c-0.02,-0.02 -0.02,-0.04 0,-0.06 0.01,-0.02 0.04,-0.02 0.06,0l0.22 0.22c0.02,0.02 0.02,0.05 0,0.06l-0.22 0.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.93 0.49c0.02,0 0.04,0.02 0.04,0.04 0,0.03 -0.02,0.05 -0.04,0.05l-0.53 0c-0.03,0 -0.04,-0.02 -0.04,-0.05 0,-0.02 0.01,-0.04 0.04,-0.04l0.53 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.70047cc6df3eb6f0d7d310b5dea30032.svg";
export { ForwardRef as ReactComponent };